import { CLEAR_SITE_DATA } from '../application';
import { DELETE_FILE_SUCCESS } from '../files';
import { PIN_FILE, REMOVE_PINNED_FILE } from './actions';

const initialState = {
  pinnedFiles: [],
};

// eslint-disable-next-line default-param-last
export function reducer(state = initialState, action) {
  switch (action.type) {
    case PIN_FILE: {
      const { fileId } = action;
      if (state.pinnedFiles.includes(fileId)) return state;

      return {
        ...state,
        pinnedFiles: [...state.pinnedFiles, fileId],
      };
    }
    case REMOVE_PINNED_FILE:
    case DELETE_FILE_SUCCESS: {
      const { fileId } = action;

      return {
        ...state,
        pinnedFiles: state.pinnedFiles.filter((id) => id !== fileId),
      };
    }
    case CLEAR_SITE_DATA: {
      // ***IMPORTANT***
      // Explicitly resetting each piece of state here because we've experienced
      // issues with stale state (in visualizations, specifically) - even when returning
      // initialState, using a spread copy of initialState as default state,
      // and/or returning a spread copy of initialState.
      return { ...state, pinnedFiles: [] };
    }
    default: {
      return state;
    }
  }
}

export default reducer;
